import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
    standalone: true,
})
export class PhonePipe implements PipeTransform {
    public transform(phone: string): string {
        phone = phone.replace('+33', '0');
        return phone;
    }
}
